import { alert, hideLoading, showLoading, snack, confirm } from './api';

export default {
  install: App => {
    App.prototype.$showLoading = App.showLoading = showLoading;
    App.prototype.$hideLoading = App.hideLoading = hideLoading;
    App.prototype.$showAlert = App.showAlert = alert;
    App.prototype.$confirm = App.confirm = confirm;
    App.prototype.$snackbar = App.snackbar = snack.info;
  },
};
